<template>
  <div class="main">
    <b-card>
      <b-card-body>
        <validation-observer ref="AddForm" #default="{ invalid }">
          <b-form @submit.prevent="SubmitPayroll">
            <b-form-group label="Employee*" label-for="employeeId">
              <validation-provider
                #default="{ errors }"
                name="Employee"
                vid="employeeId"
                rules="required"
              >
                <b-form-select
                  id="employeeId"
                  v-model="payroll.employeeId"
                  :options="employeeOptions"
                  value-field="id"
                  text-field="employeeFullName"
                  required
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group label="Status*" label-for="status">
              <validation-provider
                #default="{ errors }"
                name="Status"
                vid="status"
                rules="required"
              >
                <b-form-select
                  id="status"
                  v-model="payroll.status"
                  :options="statusOptions"
                  required
                />
                <!-- <b-form-input id="status" v-model="payroll.status" required></b-form-input> -->
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group label="Allocation Type*" label-for="allocationType">
              <validation-provider
                #default="{ errors }"
                name="Allocation Type"
                vid="allocationType"
                rules="required"
              >
                <b-form-select
                  id="allocationType"
                  v-model="payroll.allocationType"
                  :options="typeOptions"
                  required
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group label="Category*" label-for="category">
              <validation-provider
                #default="{ errors }"
                name="Category"
                vid="category"
                rules="required"
              >
                <b-form-select
                  id="category"
                  v-model="payroll.category"
                  :options="categoryOptions"
                  required
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group label="Amount*" label-for="amount">
              <validation-provider
                #default="{ errors }"
                name="Amount"
                vid="amount"
                rules="min_value:0|required"
              >
                <b-form-input
                  id="amount"
                  v-model="payroll.amount"
                  type="number"
                  step="0.01"
                    required
                    @input="checkNegative"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group label="Allocation Date" label-for="allocationDate">
              <validation-provider
                #default="{ errors }"
                name="Allocation Date"
                vid="allocationDate"
                rules="required"
              >
                <b-form-select
                  id="allocationDate"
                  v-model="payroll.allocationDate"
                  :options="allocationDate"
                  required
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="Notes" label-for="notes">
              <b-form-textarea id="notes" v-model="payroll.notes" />
            </b-form-group>

            <b-form-group label-for="isRecurring">
                <b-form-checkbox id="isRecurring" v-model="payroll.isRecurring">
                  Is Recurring?
                </b-form-checkbox>
              </b-form-group>
            <!-- <b-button type="submit" variant="primary">Save Changes</b-button> -->
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                block
                @click="SubmitPayroll()"
              >
                <b-spinner small v-if="loading" class="mx-2" />Save Changes
              </button>
            </div>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
  </div>
</template>
  
  <script>
import {
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BButton,
  BSpinner,
  BFormCheckbox,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import moment from "moment";

export default {
  components: {
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BButton,
    BSpinner,
    ValidationObserver,
    ValidationProvider,
    BFormCheckbox,
  },
  data() {
    return {
      id: this.$route.params.id,
      isEdit: this.$route.meta.isEdit,
      payroll: {
        employeeId: null,
        status: "",
        allocationType: "",
        category: "",
        amount: null,
        allocationDate: "",
        notes: "",
        isRecurring: false,
      },
      statusOptions: [
        { value: "Pending", text: "Pending" },
        { value: "Approved", text: "Approved" },
        { value: "Declined", text: "Declined" },
        { value: "Cancelled", text: "Cancelled" },
      ],
      typeOptions: [
        { value: "Income", text: "Income" },
        { value: "Deduction", text: "Deduction" },
      ],
      categoryOptions: [
        { value: "Basic", text: "Basic" },
        { value: "PAYE", text: "PAYE" },
        { value: "NSF", text: "NSF" },
        { value: "PRGF", text: "PRGF" },
        { value: "Insurance", text: "Insurance Deduction" },
        { value: "Loan", text: "Loan Deduction" },
        { value: "Bonus", text: "Bonus" },
        { value: "CSG", text: "CSG" },
        { value: "Overtime", text: "Overtime" },
        { value: "Travelling", text: "Travelling" },
      ],
      allocationDate: this.getLast12Months(),

      // employeeOptions: [
      //   { value: 1, text: 'Employee 1' },
      //   { value: 2, text: 'Employee 2' },
      //   { value: 3, text: 'Employee 3' }
      // ]
    };
  },
  computed: {
    ...mapGetters("employeeModule", {
      employeesList: "employees",
      loading: "loading",
    }),

    employeeOptions() {
    return this.employeesList.map((employee) => ({
      id: employee.id,
      employeeFullName: `${employee.firstName} ${employee.lastName}`,
    }));
  },
  },
  methods: {
    ...mapActions("employeeModule", ["getEmployeeListAction"]),
    ...mapActions("allocationModule", ["addAllocationAction"]),

    checkNegative() {
    if (this.payroll.amount < 0) {
      this.payroll.amount = 0; // Set to 0 or show a warning if needed
    }
  },
  
    successAdd() {
      this.$swal({
        title: "Allocation Added!",
        text: "You have successfully added an Allocation!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getLast12Months() {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const today = new Date();
      const currentMonth = today.getMonth();
      const currentYear = today.getFullYear();
      let last12Months = [];

      for (let i = 0; i < 12; i++) {
        let month = (currentMonth - i + 12) % 12;
        let year = currentYear - Math.ceil((i - currentMonth) / 12);
        last12Months.push(`${months[month]} ${year}`);
      }

      console.log("return date", last12Months.reverse());
      return last12Months.reverse();
    },
    // error
    errorAdd() {
      this.$swal({
        title: "Error!",
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    async SubmitPayroll() {
      let isValid = await this.$refs.AddForm.validate();
      if (isValid) {
        // Handle form submission logic here
        //console.log('Payroll Submitted:', this.payroll);
        // Perform necessary actions, such as sending data to the server
        let payload = {
          employeeId: this.payroll.employeeId,
          status: this.payroll.status,
          allocationType: this.payroll.allocationType,
          category: this.payroll.category,
          amount: this.payroll.amount,
          allocationDate: moment("01 " + this.payroll.allocationDate).format(
            "YYYY-MM-DD"
          ),
          notes: this.payroll.notes,
          isRecurring: this.payroll.isRecurring
        };
        this.addAllocationAction(payload)
          .then(() => {
            this.successAdd();
            this.payroll.employeeId = "";
            this.payroll.status = "";
            this.payroll.allocationType = "";
            this.payroll.category = "";
            this.payroll.amount = "";
            this.payroll.notes = "";
            this.payroll.allocationDate = "";
            //this.getBankListAction();
            this.$router.push("/hrmanagement/Allocations");
          })
          .catch(() => {
            this.errorAdd();
            this.payroll.employeeId = "";
            this.payroll.status = "";
            this.payroll.allocationType = "";
            this.payroll.category = "";
            this.payroll.amount = "";
            this.payroll.notes = "";
            this.payroll.allocationDate = "";
            //this.getAllocationListAction();
          });
      }
    },
  },
  async mounted() {
    this.payroll.allocationDate = this.getLast12Months()[0];

    await this.getEmployeeListAction();
  },
};
</script>
  
  <style scoped>
/* Add your existing styles here */
</style>
  